<script setup>
const seoTitle = "MIRASOFT - Consultancy";
const seoDescription = "";


useHead({
  title: seoTitle,
  meta: [
    { name: "description", content: seoDescription },
    { name: "og:title", content: seoTitle },
    { name: "og:description", content: seoDescription },
    { name: "keywords", content: "Consultancy" },
  ],
});
</script>

<template>
  <div class="home-page px-12 max-md:px-6 py-10">
    <section id="about-us" class="2xl:container m-auto max-md:pt-4">
      <div class="max-sm:hidden" data-aos="fade-up">
        <nuxt-picture
          loading="lazy"
          src="/images/frame-85.png"
          :imgAttrs="{ class: 'w-full', alt: 'home-banner' }"
          class="w-full"
        />
      </div>
      <div class="sm:hidden -mx-4" data-aos="fade-up">
        <nuxt-picture
          loading="lazy"
          src="/images/frame-88.png"
          :imgAttrs="{ class: 'w-full', alt: 'home-banner-mobile' }"
          class="w-full"
        />
      </div>
    </section>

    <section class="mt-28">
      <section class="mt-[80px] 2xl:container m-auto">
        <div class="flex max-xl:flex-col max-md:items-center" data-aos="fade-up" id="it-consulting">
          <div class="w-[50%] max-xl:w-full flex flex-col justify-between">
            <div class="max-sm:mt-6 max-2xl:pb-2 pb-2 pr-2 w-full">
              <nuxt-picture
                loading="lazy"
                src="/images/img-2.png"
                class="picture"
                :imgAttrs="{ alt: 'heading', class: 'w-full max-xl:h-full h-[360px]' }"
              />
            </div>
            <div class="max-lg:flex-col max-xl:hidden">
              <div
                class="w-full bg-white rounded-l-[20px] max-xl:ml-1 max-lg:ml-0 max-2xl:ml-1 p-9 pb-[50px] relative leading-[26px]"
              >
                <div class="mt-[35px]">
                  <h4 class="font-bold text-black text-left">CHALLENGES</h4>
                  <p class="mt-[17px] text-[18px]">
                    <strong class="text-[18px]">Convert Digital</strong> is a leading e-commerce web design and
                    development agency with offices in <strong class="text-[18px]">Melbourne, Sydney</strong> and
                    <strong class="text-[18px]">Brisbane</strong>
                    . They strive to be a partner that considers the uniqueness of their client's business and believe
                    that success can only come through mutually rewarding relationships. They require a highly skilled
                    team of e-commerce specialists, to be able to leverage the best in the industry to deliver
                    world-class eCommerce experiences.
                  </p>
                </div>
                <div class="gap-4">
                  <p class="mt-1 text-[18px]">
                    The agency’s prime objective is to utilize market-leading tools and technologies to simplify complex
                    problems by creating fully integrated, scalable, functional and high-converting websites.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-[50%] max-lg:w-full max-md:items-center flex justify-between max-xl:hidden">
            <div
              class="w-full bg-white rounded-br-[20px] rounded-t-[20px] p-4 relative max-xl:p-4 max-lg:w-full pb-[61px] max-lg:pb-[61px] max-xl:pb-[38.5px]"
            >
              <div
                class="flex items-center mb-[28px] mt-[24px] w-[148px] max-md:w-[48px] max-xl:w-[126px] max-2xl:w-[100px]"
              >
                <nuxt-picture loading="lazy" src="/images/group-1.svg" :imgAttrs="{ class: 'w-full', alt: 'icon' }" />
              </div>
              <h2 class="text-black text-[60.44px] max-md:text-[22px] max-2xl:text-[50px]">Convert Digital</h2>
              <div
                class="flex max-md:flex-col max-md:items-start items-center gap-[154px] max-xl:gap-3 pt-[94px] max-xl:pt-[46.5px] max-2xl:pt-[63px] max-lg:pt-5"
              >
                <h4 class="text-black font-bold">INDUSTRY</h4>
                <p class="text-right text-black text-[18px]">IT Services and IT Consulting</p>
              </div>
              <div class="flex max-md:flex-col max-md:items-start items-center gap-[140px] max-xl:gap-3 pt-[22px]">
                <h4 class="text-black font-bold">EXPERTISE</h4>
                <p class="text-right text-black text-[18px]">Ecommerce, Mobile App, Web App</p>
              </div>
              <div class="items-center gap-[140px] pt-[22px]">
                <h4 class="text-black font-bold">TEAM SIZE</h4>
                <p class="text-black text-[18px] pt-[10px] ml-2">
                  3 Project Manager, 5 Technical Lead, 20+ Developers.
                </p>
              </div>
              <div class="items-center gap-[140px] pt-[22px]">
                <h4 class="text-black uppercase font-bold">Support Coverage</h4>
                <p class="text-black text-[18px] pt-[10px] font-normal tracking-[-0.3px]">
                  - Build, manage and maintain eCommerce systems and management systems based on Cloud platforms.
                </p>
              </div>
              <div class="items-center gap-[140px]">
                <p class="text-black text-[18px] pt-[3px] font-normal">
                  - Integrate different ERP systems using JIM2, JIWA, Global Bake, SAP, MS Dynamic..
                </p>
              </div>
              <div class="items-center gap-[140px]">
                <p class="text-black text-[18px] pt-[3px] font-normal tracking-[-0.3px]">
                  - Support on operating, maintaining the systems.
                </p>
              </div>
            </div>
          </div>
          <div class="hidden max-xl:inline max-xl:mt-3">
            <div
              class="w-full bg-white rounded-3xl p-4 relative max-xl:w-full pb-[61px] max-lg:pb-[61px] max-xl:pb-[38.5px]"
            >
              <div
                class="flex items-center mb-[28px] mt-[24px] w-[148px] max-md:w-[48px] max-xl:w-[126px] max-2xl:w-[100px]"
              >
                <nuxt-picture loading="lazy" src="/images/group-1.svg" width="full" :imgAttrs="{ alt: 'icon' }" />
              </div>
              <h2 class="text-black text-[60px] max-md:text-[24px]">Convert Digital</h2>
              <div
                class="flex max-md:flex-col max-md:items-start items-center gap-[154px] max-md:gap-3 max-md:pt-10 pt-[96px] max-2xl:pt-[63px]"
              >
                <h4 class="text-black font-bold max-md:text-[18px]">INDUSTRY</h4>
                <p class="text-right max-sm:text-left text-black text-[18px] max-md:text-[14px]">
                  IT Services and IT Consulting
                </p>
              </div>
              <div
                class="flex max-md:flex-col max-md:items-start items-center gap-[140px] max-md:gap-3 max-md:pt-5 pt-[24px]"
              >
                <h4 class="text-black font-bold max-md:text-[18px]">EXPERTISE</h4>
                <p class="text-right max-sm:text-left text-black text-[18px] max-md:text-[14px]">
                  Ecommerce, Mobile App, Web App
                </p>
              </div>
              <div class="items-center gap-[140px] pt-[24px]">
                <h4 class="text-black font-bold max-md:text-[18px]">TEAM SIZE</h4>
                <p class="text-black text-[18px] max-md:text-[14px] pt-[12px] ml-2">
                  3 Project Manager, 5 Technical Lead, 20+ Developers.
                </p>
              </div>
              <div class="items-center gap-[140px] pt-[24px]">
                <h4 class="text-black uppercase font-bold max-md:text-[18px]">Support Coverage</h4>
                <p class="text-black text-[18px] max-md:text-[14px] pt-[12px] font-normal tracking-[-0.3px]">
                  - Build, manage and maintain eCommerce systems and management systems based on Cloud platforms.
                </p>
              </div>
              <div class="items-center gap-[140px]">
                <p class="text-black text-[18px] max-md:text-[14px] pt-[6px] font-normal">
                  - Integrate different ERP systems using JIM2, JIWA, Global Bake, SAP, MS Dynamic..
                </p>
              </div>
              <div class="items-center gap-[140px]">
                <p class="text-black text-[18px] max-md:text-[14px] pt-[8px] font-normal tracking-[-0.3px]">
                  - Support on operating, maintaining the systems.
                </p>
              </div>
              <div class="mt-[35px]">
                <h4 class="font-bold text-black text-left max-md:text-[18px]">CHALLENGES</h4>
                <p class="mt-[17px] text-[18px] max-md:text-[14px] leading-[20px]">
                  <strong class="text-[18px] max-md:text-[14px] leading-[20px]">Convert Digital</strong> is a leading
                  e-commerce web design and development agency with offices in
                  <strong class="text-[18px] max-md:text-[14px] leading-[20px]">Melbourne, Sydney</strong> and
                  <strong class="text-[18px] max-md:text-[14px] leading-[20px]">Brisbane</strong>
                  . They strive to be a partner that considers the uniqueness of their client's business and believe
                  that success can only come through mutually rewarding relationships. They require a highly skilled
                  team of e-commerce specialists, to be able to leverage the best in the industry to deliver world-class
                  eCommerce experiences.
                </p>
                <div class="mt-2">
                  <p class="mt-1 text-[18px] max-md:text-[14px] leading-[20px]">
                    The agency’s prime objective is to utilize market-leading tools and technologies to simplify complex
                    problems by creating fully integrated, scalable, functional and high-converting websites.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex max-xl:flex-col max-md:items-center mt-24 max-xl:mt-3" data-aos="fade-up" id="it-services">
          <div class="w-[50%] flex justify-between max-lg:w-full max-md:items-center max-xl:hidden">
            <div
              class="w-full bg-white rounded-bl-[20px] rounded-t-[20px] p-6 pl-[41px] relative max-lg:w-full pb-[81px] max-lg:pb-[61px] max-xl:pb-[38.5px]"
            >
              <div
                class="flex items-center mb-[28px] mt-[24px] w-[148px] max-md:w-[48px] max-xl:w-[126px] max-2xl:w-[100px]"
              >
                <nuxt-picture loading="lazy" src="/images/group-2.svg" width="full" :imgAttrs="{ alt: 'icon' }" />
              </div>
              <h2 class="text-black text-[60.44px] max-md:text-[24px] max-2xl:text-[50px]">XPON Group</h2>
              <div
                class="flex max-md:flex-col max-md:items-start items-center gap-[154px] max-xl:gap-3 pt-[96px] max-xl:pt-[46.5px] max-2xl:pt-[63px] max-lg:pt-5"
              >
                <h4 class="text-black font-bold">INDUSTRY</h4>
                <p class="text-right text-black text-[18px]">IT Services and IT Consulting</p>
              </div>
              <div class="flex max-md:flex-col max-md:items-start items-center gap-[141px] max-xl:gap-3 pt-[24px]">
                <h4 class="text-black font-bold">EXPERTISE</h4>
                <p class="text-right text-black text-[18px]">Ecommerce, Salesforce CRM</p>
              </div>
              <div class="pt-[24px]">
                <h4 class="text-black uppercase font-bold">SOLUTION</h4>
                <div class="ml-7">
                  <p class="text-black text-[18px] pt-[12px] font-normal tracking-[-0.3px]">
                    - Separate Business Units with different flow and data
                  </p>
                  <p class="text-black text-[18px] pt-[6px] font-normal tracking-[-0.3px]">
                    - Sales Cloud & Pardot Setup (Users & Permissions).
                  </p>
                  <p class="text-black text-[18px] pt-[8px] font-normal tracking-[-0.3px]">
                    - Two-way synchronization between Pardot Prospect and SF Lead/Contact
                  </p>
                  <p class="text-black text-[18px] pt-[8px] font-normal tracking-[-0.3px]">
                    - Database Migration (Lead | Opportunity | Contact | Account | User | Role)
                  </p>
                  <p class="text-black text-[18px] pt-[8px] font-normal tracking-[-0.3px]">
                    - Reports & Dashboards Configuration
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-[50%] flex max-xl:w-full max-xl:mt-3 flex-col justify-between">
            <div class="max-xl:ml-0 mb-2 ml-2">
              <nuxt-picture
                loading="lazy"
                src="/images/img-3.png"
                class="picture"
                :imgAttrs="{ alt: 'heading', class: 'w-full max-xl:h-full h-[360px]' }"
              />
            </div>
            <div class="max-lg:flex-col max-xl:hidden max-2xl:-ml-1">
              <div
                class="w-full bg-white rounded-r-[20px] max-xl:ml-1 max-lg:ml-0 max-2xl:-ml-1 p-9 pb-[55px] max-2xl:pb-[59px] relative leading-[26px]"
              >
                <div class="pt-[35px]">
                  <h4 class="font-bold text-black text-left">ABOUT CLIENT</h4>
                  <p class="mt-[17px] text-[18px] text-justify">
                    <strong>XPON</strong> is a founder-led Marketing Technology and Cloud Business providing
                    mission-critical services and software solutions to businesses in Australia, New Zealand, the United
                    Kingdom and Europe.
                  </p>
                </div>
                <div class="gap-4">
                  <p class="mt-10 text-[18px]">
                    <strong>XPON</strong> T is a remote-first organization, with more than 135 talented colleagues
                    around the globe. They are united in their purpose and Core Values - and approach their work knowing
                    that they can realize Limitless Potential when they are Brave Enough; Lead with Curiosity; Own It;
                    and Grow Together..
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden max-xl:inline max-xl:mt-4">
            <div
              class="w-full bg-white rounded-3xl p-4 relative max-xl:w-full pb-[61px] max-lg:pb-[61px] max-xl:pb-[38.5px]"
            >
              <div
                class="flex items-center mb-[28px] mt-[24px] w-[148px] max-md:w-[48px] max-xl:w-[126px] max-2xl:w-[100px]"
              >
                <nuxt-picture loading="lazy" src="/images/group-2.svg" width="full" :imgAttrs="{ alt: 'icon' }" />
              </div>
              <h2 class="text-black text-[60.44px] max-md:text-[24px]">XPON Group</h2>
              <div
                class="flex max-md:flex-col max-md:items-start items-center gap-[154px] max-md:gap-3 max-md:pt-10 pt-[96px] max-2xl:pt-[63px]"
              >
                <h4 class="text-black font-bold max-md:text-[18px]">INDUSTRY</h4>
                <p class="text-right max-sm:text-left text-black text-[18px] max-md:text-[14px]">
                  IT Services and IT Consulting
                </p>
              </div>
              <div
                class="flex max-md:flex-col max-md:items-start items-center gap-[140px] max-md:gap-3 max-md:pt-5 pt-[24px]"
              >
                <h4 class="text-black font-bold max-md:text-[18px]">EXPERTISE</h4>
                <p class="text-right max-sm:text-left text-black text-[18px] max-md:text-[14px]">
                  Ecommerce, Mobile App, Web App
                </p>
              </div>
              <div class="pt-[24px]">
                <h4 class="text-black uppercase font-bold max-md:text-[18px]">SOLUTION</h4>
                <div class="ml-2">
                  <p class="text-black text-[18px] max-md:text-[14px] pt-[12px] font-normal tracking-[-0.3px]">
                    - Separate Business Units with different flow and data
                  </p>
                  <p class="text-black text-[18px] max-md:text-[14px] pt-[6px] font-normal tracking-[-0.3px]">
                    - Sales Cloud & Pardot Setup (Users & Permissions).
                  </p>
                  <p class="text-black text-[18px] max-md:text-[14px] pt-[8px] font-normal tracking-[-0.3px]">
                    - Two-way synchronization between Pardot Prospect and SF Lead/Contact
                  </p>
                  <p class="text-black text-[18px] max-md:text-[14px] pt-[8px] font-normal tracking-[-0.3px]">
                    - Database Migration (Lead | Opportunity | Contact | Account | User | Role)
                  </p>
                  <p class="text-black text-[18px] max-md:text-[14px] pt-[8px] font-normal tracking-[-0.3px]">
                    - Reports & Dashboards Configuration
                  </p>
                </div>
              </div>
              <div class="mt-[35px]">
                <h3 class="font-bold text-black text-left max-md:text-[18px]">ABOUT CLIENT</h3>
                <p class="mt-[17px] text-[18px] max-md:text-[14px]">
                  <strong>XPON</strong> is a founder-led Marketing Technology and Cloud Business providing
                  mission-critical services and software solutions to businesses in Australia, New Zealand, the United
                  Kingdom and Europe.
                </p>
              </div>
              <div class="gap-4">
                <p class="mt-10 text-[18px] max-md:text-[14px]">
                  <strong>XPON</strong> T is a remote-first organization, with more than 135 talented colleagues around
                  the globe. They are united in their purpose and Core Values - and approach their work knowing that
                  they can realize Limitless Potential when they are Brave Enough; Lead with Curiosity; Own It; and Grow
                  Together..
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>

    <Excellence class="mt-[80px]" />
  </div>
</template>
